import(/* webpackMode: "eager" */ "/root/repo/src/app/score-check/personal/page.tsx");
